import React, { useState, useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { makeStyles } from '@material-ui/core';
import NavBar from './NavBar';
import TopBar from './TopBar';
import { useDispatch } from 'react-redux';
import { logoutUser } from 'src/store/actions/AuthActions';
import { NotificationManager } from 'react-notifications';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    display: 'flex',
    height: '100%',
    overflow: 'hidden',
    width: '100%'
  },
  wrapper: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden',
    paddingTop: 64,
    [theme.breakpoints.up('lg')]: {
      paddingLeft: 256
    }
  },
  contentContainer: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden'
  },
  content: {
    flex: '1 1 auto',
    height: '100%',
    overflow: 'auto'
  }
}));

const availableEvents = [
  'load',
  'mousemove',
  'mousedown',
  'click',
  'scroll',
  'keypress'
];

const DashboardLayout = () => {
  const classes = useStyles();
  const [isMobileNavOpen, setMobileNavOpen] = useState(false);
  const dispatch = useDispatch();
  let handleClearTimeout;

  const destroyTimeout = () => {
    // if timer is active, clear it first
    if (handleClearTimeout) clearTimeout(handleClearTimeout);
    // for (let i in availableEvents) {
    //   window.removeEventListener(availableEvents[i], resetTimeout);
    // }

    // refactored the above loop to this.
    Object.keys(availableEvents).forEach((item) =>
      window.removeEventListener(availableEvents[item], resetTimeout)
    );
  };

  const handleSetTimeout = () => {
    handleClearTimeout = setTimeout(() => {
      destroyTimeout();
      // NotificationManager.info('Session Timeout', 'Session Timeout');
      dispatch(logoutUser());
      window.location.pathname = '/login';
    }, 300000);
  };

  const resetTimeout = () => {
    clearTimeout(handleClearTimeout);
    handleSetTimeout();
  };

  useEffect(() => {
    handleSetTimeout();

    Object.keys(availableEvents).forEach((item) =>
      window.addEventListener(availableEvents[item], resetTimeout)
    );
  }, []);

  return (
    <div className={classes.root}>
      <TopBar onMobileNavOpen={() => setMobileNavOpen(true)} />
      <NavBar
        onMobileClose={() => setMobileNavOpen(false)}
        openMobile={isMobileNavOpen}
      />
      <div className={classes.wrapper}>
        <div className={classes.contentContainer}>
          <div className={classes.content}>
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardLayout;
